import { Select, Option } from 'element-ui'
import HttpFactory from '@/mixins/http.factory';
import download from "downloadjs";
import customAgGrid from '@/components/custom-ag-grid/custom-ag-grid.vue';
import dateTimeRenderer from '@/components/custom-ag-grid/dateTimeRenderer/dateTimeRenderer.vue';
import booleanRenderer from '@/components/custom-ag-grid/booleanRenderer/booleanRenderer.vue';
import paymentActionsRenderer from '@/components/admin/paymentActionsRenderer.vue';
import DatePicker from '@/components/date-picker/date-picker.vue';
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import copyColumnRenderer from '@/components/admin/copy-column.vue';
export default {
	mixins:[HttpFactory],
	data () {
		return {
            filters:{searchText:null},
            payments:{showPayments:false,list:[],user:null,columnDefs:[]},
			customer:null,
            editPayment:null,
            editIndex:-1,
            showPaymentModal:false,
            payment:null,
            customers:[],
            showCustomer:false,
            drpCustomers:[],
            planList: [],
            paymentsView: {
                mbrCustomers: 0,
                devOpsCustomers:0,
                mbrPayments: 0,
                devOpsPayments: 0,
                totalPayments:0,
            }
		};
	},
	created(){
        const _self=this;
        _self.initCols();
		_self.init();
	},
	methods:{
        async init(){
            const _self=this;
            let planList = this.priceList.map(function (item) {
                return {
                    id: item.name,
                    name: item.name,
                    label:item.name
                }
            }); 
            planList = planList.concat([
                { id: "basic_plan", name: 'Basic Plan monday', label: 'Basic Plan monday' },
                { id: "premium_plan", name: 'Premium Plan monday', label: 'Premium Plan monday' },
                { id: "enterprise_plan", name: 'Enterprise Plan monday', label: 'Enterprise Plan monday' },
                { id: "on_premise_plan", name: 'On-Premise Plan monday', label: 'On-Premise Plan monday' }
            ]);
            _self.planList = planList;
            
            this.fetchCustomersData(function(){
                _self.fetchData();
            });
            
        },
        async fetchData(){
            const _self=this;
            //_self.fn().clearMessage();
            try{
                let response=await _self.get('payments');
                if(response && response.data){
                    let payments=response.data.Data;
                    payments = _self.fn().sortNumCol(payments, 'id');
                    _self.handlePaymentsView(payments);
                    _self.payments.list = payments;
                }else{
                    _self.userMsg.list=['An error occurred!! Please try again later'];
                }
            }catch(ex){
				_self.commonErrorMsgDisp(ex);
			}finally{
				_self.userMsg.show=true;
				_self.fn().showLoader(false);
			}
        },
        handlePaymentsView(payments) {
            const _self = this;
            let mbrData = payments.filter(d => d.invoiceNumber.indexOf('DI') >= 0);
            let devopsData = payments.filter(d => d.invoiceNumber.indexOf('DOI') >= 0 || d.invoiceNumber.indexOf('Freshworks') >= 0);
            _self.paymentsView = {
                mbrCustomers: mbrData.length,
                devOpsCustomers: devopsData.length,
                mbrPayments: mbrData.map(d=>parseFloat(d.paidAmount)).reduce(function(a, b) { return a + b; }, 0),
                devOpsPayments: devopsData.map(d=>parseFloat(d.paidAmount)).reduce(function(a, b) { return a + b; }, 0),
                totalPayments: payments.map(d=>parseFloat(d.paidAmount)).reduce(function(a, b) { return a + b; }, 0),
            };
        },
        onGridOptionsApi(params){
            this.gridOptionsApi=params;
        },
        async filterData(){
            const _self=this;
            const searchText=_self.filters.searchText;
            _self.gridOptionsApi.api.setQuickFilter(searchText);
        },
        extraCallBackFn(params){
            const _self=this;
            let editPayment=params.data;
            editPayment.startDateD=new Date(editPayment.startDate)
            editPayment.endDateD=new Date(editPayment.endDate)
            _self.editIndex=params.rowIndex;
            _self.editPayment=editPayment;
            _self.onAppNameSelect(true);
            //this.editPayment.userId=params.data.userId;
            setTimeout(function(){
                _self.showPaymentModal=true;
            },500);
            
        },
        extraCallBackFn1(params){
            const _self=this;
            let data=params.data;
            if(data.isActive==1 && confirm(`Are you sure? You are about to Disable`)){
                data.isActive=data.isActive==1?0:1;
                _self.updatePayment(data);
            }
            else if(data.isActive==0 && confirm(`Are you sure? You are about to activate`)){
                data.isActive=data.isActive==1?0:1;
                _self.updatePayment(data);
            }
        },
        extraCallBackFn2(params){
            const _self=this;
            let data=params.data;
            if(confirm(`Are you sure? You are about to delete`)){
                data.isDeleted=data.isDeleted==1?0:1;
                _self.updatePayment(data);
            }
            
        },
        //customer view
        async extraCallBackFn3(params){
            const _self=this;
            _self.customer=params.data.customer?params.data.customer:params.data;
            if(_self.customer){
                setTimeout(function(){_self.showCustomer=true;},500);
            }else{
                alert('Customer Object is null');
            }
        },
        async extraCallBackFn4(params){
            const _self=this;
            let data=params.data;
            delete data.id;
            data.userId=data.userEmail?data.userId:null;

            let startDate=new Date();
            let endDate=new Date();
            if(data.planType=='yearly'){
                endDate.setMonth(endDate.getMonth()+12);
            }else{
                endDate.setMonth(endDate.getMonth()+1);
            }
            data.startDateD=startDate;
            data.endDateD=endDate;
            data['startDate']=_self.fn().apiFormatedDate(startDate);
            data['endDate']=_self.fn().apiFormatedDate(endDate);
            data.validUntil=data.endDate;
            data.invoiceNumber=null;
            data.notes=null;
            
            _self.editPayment=data;
            _self.editIndex=-1;
            _self.onAppNameSelect(true);
            setTimeout(function(){
                _self.showPaymentModal=true;
            },500);
        },
        //extend month
        async extraCallBackFn6(params){
            const _self=this;
            let data=params.data;
            if(data.userEmail && confirm(`Are you sure? You want to extend the validity!!!for App:${data.requestType} for email:${data.userEmail}`)){
            }else{
                return;
            }
            //delete data.id;
            data.userId=data.userEmail?data.userId:null;
            delete data.customer;
            let startDate=new Date();
            let endDate=new Date(data.endDate);
            if(data.planType=='yearly'){
                endDate.setMonth(endDate.getMonth()+12);
            }else{
                //endDate.setMonth(endDate.getMonth()+1);
                endDate.addMonths(1);
            }
            data.startDateD=startDate;
            data.endDateD=endDate;
            data['startDate']=_self.fn().apiFormatedDate(startDate);
            data['endDate']=_self.fn().apiFormatedDate(endDate);
            data.validUntil=data.endDate;
            _self.editPayment=data;
            await _self.addUpdatePayment();
            _self.fetchData();
        },
        async extraCallBackFn5(params){
            const _self=this;
            _self.fn().clearMessage();
            try{
                _self.hidePayments();
                let data={
                    userId:params.data.userId,
                    requestType:params.data.requestType
                };
                let response=await _self.get(`payments/user/${data.userId}/${data.requestType}`);
                if(response && response.data){
                    _self.payments.list=response.data.Data;
                    _self.payments.user=params.data;
                    _self.payments.showPayments=true;
                }else{
                    _self.userMsg.list=['An error occurred!! Please try again later'];
                    _self.userMsg.show=true;
                }
            }catch(ex){
				_self.commonErrorMsgDisp(ex);
                _self.userMsg.show=true;
			}finally{
				_self.fn().showLoader(false);
			}
        },
        hideCustomer(){
            const _self=this;
            _self.showCustomer=false;
            setTimeout(function(){_self.customer=null;},500);
        },
        async updatePayment(params){
            const _self=this;
            _self.fn().clearMessage();
            try{
                let data={
                    id:params.id,
                    userId:params.userId,
                    isActive:params.isActive,
                    isDeleted:params.isDeleted,
                    appName:params.appName
                };
                let response=await _self.put(`payments/${data.id}/${data.userId}/${data.appName}`,data);
                if(response && response.data){
                    _self.userMsg.type='info';
                    _self.userMsg.list=['Data updated successfully'];
                    _self.fetchData();
                }else{
                    _self.userMsg.list=['An error occurred!! Please try again later'];
                }
            }catch(ex){
				_self.commonErrorMsgDisp(ex);
			}finally{
				_self.userMsg.show=true;
				_self.fn().showLoader(false);
			}
        },
        addNewPayment(){
            const _self=this;
            this.editPayment=this.getDefaultPayment();;
            this.editIndex=-1;
            setTimeout(function(){
                _self.showPaymentModal=true;
            },500);
        },
        async addUpdatePayment(){
            const _self=this;
            _self.fn().clearMessage();
            try{
                let data=_self.editPayment;
                data.startDate=_self.fn().apiFormatedDate(new Date(data.startDate));
                data.endDate=_self.fn().apiFormatedDate(new Date(data.endDate));
                data.validUntil=data.endDate;
                data.isActive=parseInt(data.isActive);
                let url=``;
                let response;
                if(data.id>0){
                    url=`payments/${data.id}/${data.userId}/${data.appName}`
                    response=await _self.put(url,data);
                }else{
                    url=`payments`
                    response=await _self.post(url,data);
                }
                if(response && response.data && response.data.Success){
                    _self.userMsg.type='info';
                    _self.userMsg.list=['Data saved successfully'];
                    _self.fetchData();

                    _self.clearPaymentEdit();
                }else{
                    _self.userMsg.list=['An error occurred!! Please try again later'];
                }
            }catch(ex){
				_self.commonErrorMsgDisp(ex);
			}finally{
				_self.userMsg.show=true;
				_self.fn().showLoader(false);
			}
        },
        clearPaymentEdit(){
            const _self=this;
            _self.showPaymentModal=false;
            _self.editIndex=-1;
            _self.drpCustomers=[];
            //_self.editPayment=_self.getDefaultPayment();
        },
        async fetchCustomersData(cb){
            const _self=this;
            //_self.fn().clearMessage();
            try{
                let response=await _self.get('customers?isActive=True');
                if(response && response.data){
                    _self.customers=response.data.Data;
                }else{
                    _self.userMsg.list=['An error occurred!! Please try again later'];
                }
            }catch(ex){
				_self.commonErrorMsgDisp(ex);
			}finally{
				_self.userMsg.show=true;
                if(cb) cb();
				//_self.fn().showLoader(false);
			}
        },
        getDefaultPayment(){
            const _self=this;
            let startDate=new Date();
            this.editPayment={
                startDateD:startDate,
                startDate:_self.fn().apiFormatedDate(startDate),
                appName:'',
                userId:'',
                planName:'',
                planType:'',
                customerType:'',
                planValidity:0, 
                agentsCount:0,
                ticketsCount:0,
                isActive:'1',
                
            }
            return this.editPayment;
        },
        onAppNameSelect(keepDefault){
            const _self=this;
            _self.drpCustomers=[];
            if(keepDefault!==true)
                _self.editPayment.userId='';
            let drpCustomers=_self.customers.filter(d=>d.requestType==_self.editPayment.appName);
            setTimeout(function(){_self.drpCustomers=drpCustomers;},300);
        },
        planNameSelect(){
            let plan = this.priceList.find(d => d.name == this.editPayment.planName);
            if (plan) {
                this.editPayment.paidAmount = plan.cost;
                this.editPayment.agentsCount = plan.agentsCount;
                this.editPayment.ticketsCount = plan.ticketsCount;
            }
        },
        onDateChanged(date,el){
            const _self=this;
            
            if(date){
                date.setDate(date.getDate()+1);//its going one day as in India usage
            }
            let referenceName=el.target.getAttribute('referenceName');
			_self.editPayment[referenceName]=date?_self.fn().apiFormatedDate(date):null;

            if(date && referenceName=='endDate' && _self.editPayment.startDate){
                _self.editPayment.validUntil=_self.editPayment.endDate;
                _self.editPayment.planValidity=_self.fn().monthDiff(new Date(_self.editPayment.startDate),new Date(_self.editPayment.endDate));
               
            }
        },
        hidePayment(){
            this.showPaymentModal=false;
            //this.editPayment={};
            this.editIndex=-1;
        },
        exportData(){
			let _self=this;
			let payments=_self.payments.list;
			//_self.fn().sortNumCol(customers,'createdOn',true);
			let defaultNullVal='-';
			let fileName = `payments.csv`;
			let csvData = `Login Url, App Name, Plan Name, Paid Amount, Valid Until, Plan Validity, Invoice Number, Customer Type, Start Date, End Date, Plan Type, Notes, Active, CreatedOn \r\n`;
			payments.forEach(function (item) {
                item.customer=item.customer==null?{}:item.customer;
				let row = `${_self.fn().formatCSV(item.hdLoginUrl?item.hdLoginUrl:defaultNullVal)},${_self.fn().formatCSV(item.appName?item.appName:defaultNullVal)},${_self.fn().formatCSV(item.paidAmount?item.paidAmount:defaultNullVal)},${_self.fn().formatCSV(item.validUntil?item.validUntil:defaultNullVal)},${_self.fn().formatCSV(item.planValidity?item.planValidity:defaultNullVal)},${_self.fn().formatCSV(item.invoiceNumber?item.invoiceNumber:defaultNullVal)},${_self.fn().formatCSV(item.customerType?item.customerType:defaultNullVal)},${_self.fn().formatCSV(item.startDate?item.startDate:defaultNullVal)},${_self.fn().formatCSV(item.endDate?item.endDate:defaultNullVal)},${_self.fn().formatCSV(item.planType?item.planType:defaultNullVal)} ,${_self.fn().formatCSV(item.notes?item.notes:defaultNullVal)},${_self.fn().formatCSV(item.isActive?item.isActive:defaultNullVal)},${_self.fn().formatCSV(item.createdOn?item.createdOn:defaultNullVal)}`;
				csvData += row + "\r\n";
			});
			download(csvData, fileName, 'data:application/csv;charset=utf-8');
		},
        initCols(){
            const _self  =this;
            let commonWidth=125;//=120;
            _self.payments.columnDefs = [
                { headerName: 'Actions',field: 'hdLoginUrl',width: commonWidth,cellRendererFramework:paymentActionsRenderer },
                { headerName: 'User Id', field: 'userId',width: commonWidth},
                { headerName: 'User Email', field: 'userEmail',width: commonWidth,cellRendererFramework:copyColumnRenderer,
                    valueFormatter(params){
                        return `${params.value?params.value:params.data.hdEmail}`;
                    } 
                },
                //{ headerName: 'DevOps Url',field: 'customer.devOpsUrl',width: commonWidth },
                { headerName: 'Id',field: 'id',width: commonWidth },
                { headerName: 'App Name', field: 'appName',width: commonWidth },
                { headerName: 'End Date', field: 'endDate',width: commonWidth ,cellRendererFramework:dateTimeRenderer },
                { headerName: 'Start Date', field: 'startDate',width: commonWidth ,cellRendererFramework:dateTimeRenderer },
                { headerName: 'Valid Until', field: 'validUntil',width: commonWidth, cellRendererFramework:dateTimeRenderer },
                { headerName: 'Plan Name', field: 'planName', width: commonWidth,cellClass:'text-left'},
                { headerName: 'Paid Amount', field: 'paidAmount',width: commonWidth },
                { headerName: 'Plan Validity', field: 'planValidity',width: commonWidth },
                { headerName: 'Invoice Number', field: 'invoiceNumber',width: commonWidth },
                { headerName: 'Customer Type', field: 'customerType',width: commonWidth },
                
                { headerName: 'Plan Type', field: 'planType',width: commonWidth },
                { headerName: 'Notes', field: 'notes',width: commonWidth },
                { headerName: 'Agents Count', field: 'agentsCount',width: commonWidth },
                { headerName: 'Tickets Count', field: 'ticketsCount',width: commonWidth },
                { headerName: 'HD Login',field: 'customer.hdLoginUrl',width: commonWidth },
                { headerName: 'Active', field: 'isActive',width: commonWidth,cellRendererFramework:booleanRenderer},
                { headerName: 'Deleted', field: 'isDeleted',width: commonWidth,cellRendererFramework:booleanRenderer},
                { headerName: 'Created On', field: 'createdOn',width: commonWidth,cellRendererFramework:dateTimeRenderer },
            ];
        },
        initUserCols(){
            const _self  =this;
            let commonWidth=125;//=120;
            _self.columnDefs = [
            { headerName: 'Actions',field: 'userId',minWidth:400,width: commonWidth,cellRendererFramework:customerActionsRenderer },
            { headerName: 'App Name',pinned:'left', field: 'requestType',width: commonWidth },
            { headerName: 'User Id', field: 'userId', width: commonWidth,cellClass:'text-left'},
            { headerName: 'App Id', field: 'appId',width: commonWidth },
            { headerName: 'Installation Id', field: 'installationId',width: commonWidth },
            { headerName: 'User Name', field: 'userName',width: commonWidth },
            { headerName: 'User Email', field: 'userEmail',width: commonWidth },
            { headerName: 'HD Email', field: 'hdEmail',width: commonWidth },
            { headerName: 'HD Login Url', field: 'hdLoginUrl',width: commonWidth },
            { headerName: 'HD Token', field: 'hdToken',width: commonWidth },
            { headerName: 'DevOps Url', field: 'devOpsUrl',width: commonWidth },
            { headerName: 'DevOps Token', field: 'devOpsToken',width: commonWidth },
            { headerName: 'Allowed Count', field: 'allowedCount',width: commonWidth },
            { headerName: 'Syncing Allowed', field: 'syncAllowed',width: commonWidth },
            { headerName: 'DevOps Status', field: 'devopsStatus',width: commonWidth },
            { headerName: 'D Status Desc', field: 'devopsStatusDesc',width: commonWidth },
            { headerName: 'Allowed Tags', field: 'allowTags',width: commonWidth,cellRendererFramework:booleanRenderer },
            { headerName: 'Valid Until', field: 'validUntil',width: commonWidth,cellRendererFramework:dateTimeRenderer },
            { headerName: 'Token Valid', field: 'isTokenValid',width: commonWidth,cellRendererFramework:booleanRenderer },
            { headerName: 'Active', field: 'isActive',width: commonWidth,cellRendererFramework:booleanRenderer},
            { headerName: 'Deleted', field: 'isDeleted',width: commonWidth,cellRendererFramework:booleanRenderer},
            { headerName: 'Paid',pinned:'right', field: 'isPaid',width: commonWidth,cellRendererFramework:booleanRenderer },
            { headerName: 'Premium', field: 'isPremium',width: commonWidth ,cellRendererFramework:booleanRenderer},
            { headerName: 'Users API', field: 'isUsersAccess',width: commonWidth ,cellRendererFramework:booleanRenderer},
            { headerName: 'Tickets Count', field: 'linkedCount',width: commonWidth },
            { headerName: 'Last Tickets', field: 'lastDayCount',width: commonWidth },
            { headerName: 'Last Used On', field: 'lastDayUsedOn',width: commonWidth,cellRendererFramework:dateTimeRenderer },
            { headerName: 'Created On', field: 'createdOn',width: commonWidth,cellRendererFramework:dateTimeRenderer },
            ];

        },
    },
    components:{customAgGrid,DatePicker,vSelect,[Select.name]: Select,[Option.name]: Option},
}

